import moment from 'moment';
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { postMABAA060 } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import { formatDate, formatNumberWithCommas, getResultText } from '../../../utils';

const MABAA060 = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    useEffect(() => {
        postMABAA060(id, { size: 5, page })
            .then(({ data }) => {
                setData(data.data);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    }, [id, page]);

    return (
        <div className="profile-content">
            <div className="title-profile">지원목록</div>
            <div className="member-basic-infor">
                <div className="title-table-info">지원목록</div>
                <div className="profile-content-count">
                    총 <span className="total">{formatNumberWithCommas(pages?.totalRow || 0)}</span>건
                </div>
                <table className="table table-bordered member-infor">
                    <thead>
                        <tr>
                            <th style={{ width: '12%' }}>지원일</th>
                            <th style={{ width: '12%' }}>열람일</th>
                            <th style={{ width: '12%' }}>지원기관</th>
                            <th style={{ width: '40%' }}>지원한 채용 공고</th>
                            <th style={{ width: '12%' }}>채용상태</th>
                            <th style={{ width: '12%' }}>지원결과</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? (
                            data.map((item, index) => {
                                const acceptDate = moment(item?.acceptDate).format('YYYY.MM.DD');
                                const currentDate = moment();
                                const isRecruiting = currentDate.isBetween(
                                    item?.recRecruitFrom,
                                    item?.recRecruitEnd,
                                    null,
                                    '[]',
                                );
                                return (
                                    <tr key={index}>
                                        <td>{formatDate(item?.applyDate)}</td>
                                        <td>
                                            {item?.acceptYN === 'N' ? (
                                                '미열람'
                                            ) : (
                                                <div>
                                                    열람
                                                    <div>{acceptDate}</div>
                                                </div>
                                            )}
                                        </td>
                                        <td>{item?.recCompany}</td>
                                        <td>
                                            {item?.recTitle} <br /> {formatDate(item?.recRecruitFrom)} ~{' '}
                                            {formatDate(item?.recRecruitEnd)}
                                        </td>
                                        <td>{isRecruiting ? '채용중' : '채용종료'}</td>
                                        <td>{getResultText(item?.result)}</td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td style={{textAlign:'center'}} colSpan={6}>데이타가 없습니다.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <Pagination pages={pages} />
            </div>
        </div>
    );
};
export default MABAA060;
